import { useEffect, useState } from "react";

import { useDataProvider } from "ra-core";

const useEvalJudgments = () => {
  const [items, setItems] = useState([]);
  const dataProvider = useDataProvider();
  useEffect(() => {
    dataProvider
      .getList("eval-judgments", {
        pagination: { page: 1, perPage: 20 },
        sort: { field: "id", order: "ASC" },
      })
      .then(({ data }) => setItems(data));
  }, [dataProvider]);
  return items;
};

export default useEvalJudgments;
